<script lang="ts">
  import { testSubPermission } from 'dbgate-tools';
  import ExtendedCheckBoxField from '../forms/ExtendedCheckBoxField.svelte';

  export let permission;
  export let label;

  export let permissions;
  export let basePermissions;

  export let onSetPermission;

  $: baseThisPermissionValue = testSubPermission(permission, permissions, false);

  // permission value from base
  $: basePermissionValue =
    baseThisPermissionValue == null ? testSubPermission(permission, basePermissions) : baseThisPermissionValue;

  $: value = permissions.includes(permission) ? true : permissions.includes('~' + permission) ? false : null;

  function handleChange(newValue) {
    onSetPermission(permission, newValue);
  }

  // $: console.log('PERM CHECK', permission, value, basePermissionValue);
</script>

<ExtendedCheckBoxField {label} {value} inheritedValue={basePermissionValue} onChange={handleChange} />
